export const TOGGLE_ALERT = "TOGGLE_ALERT";

export const toggleAlert = (message,reload) => dispatch => {
    const data = {
        message,
        isReload: reload
    }
    return dispatch({ type: TOGGLE_ALERT, payload: data});
};
